'use strict';

// Used for endpoint.type
module.exports = {
    INTERNAL: 'INTERNAL',
    PARTNER: 'PARTNER'
};